import React, { useEffect } from "react";
import { Modal, Form, Input, Button, Space } from "antd";
import { MinusCircleOutlined } from "@ant-design/icons";

const ExtraChangesModal = ({
    isModalVisible,
    handleOk,
    handleCancel,
    loading,
    onFinish,
    form,
    extra = []
}) => {
    useEffect(() => {
        if (isModalVisible) {
            if (extra.length > 0) {
                form.setFieldsValue({
                    charges: extra.map(item => ({
                        first: item.extra_charge,
                        last: item.extra_charge_amount,
                    })),
                });
            } else {
                // reset if no extra charges
                form.setFieldsValue({
                    charges: [{ first: "", last: "" }],
                });
            }
        }
    }, [isModalVisible, extra, form]);
    return (
        <Modal
            title={
                <div style={{ width: "100%" }}>
                    Add Extra Charges
                    <div
                        style={{
                            borderTop: "1px solid #ccc",
                            marginTop: "15px",
                            marginBottom: "12px",
                        }}
                    ></div>
                </div>
            }
            open={isModalVisible}
            onOk={handleOk}
            onCancel={handleCancel}
            footer={null}
            closable={true}
            width={550}
            style={{ padding: "10px" }}
        >
            <div
                style={{
                    padding: "10px",
                    // border: "1px solid #ccc",
                    borderRadius: "8px",
                    backgroundColor: "#FFFFFF",
                }}
            >
                <Form
                    name="dynamic_form_nest_item"
                    onFinish={onFinish}
                    form={form}
                    layout="vertical"
                    style={{
                        paddingTop: "20px",
                    }}
                    autoComplete="off"
                >
                    <Form.List name="charges">
                        {(fields, { add, remove }) => (
                            <>
                                {fields.map(({ key, name, ...restField }) => (
                                    <Space
                                        key={key}
                                        style={{
                                            display: "flex",
                                            marginBottom: 8,
                                        }}
                                        size={12}
                                    >
                                        <Form.Item
                                            {...restField}
                                            label="Extra Charges"
                                            name={[name, "first"]}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Missing description",
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Description" />
                                        </Form.Item>
                                        <Form.Item
                                            {...restField}
                                            label="Charges"
                                            name={[name, "last"]}
                                            rules={[
                                                {
                                                    required: true,
                                                    message: "Missing Charges",
                                                },
                                            ]}
                                        >
                                            <Input placeholder="Charges" />
                                        </Form.Item>
                                        <MinusCircleOutlined
                                            onClick={() => remove(name)}
                                            style={{ marginTop: "10px" }}
                                        />
                                    </Space>
                                ))}
                                <Form.Item>
                                    <Button type="dashed" onClick={() => add()}>
                                        Add Extra Charges
                                    </Button>
                                </Form.Item>
                            </>
                        )}
                    </Form.List>
                    <Form.Item>
                        <Button type="primary" htmlType="submit" loading={loading}>
                            Submit
                        </Button>
                    </Form.Item>
                </Form>
            </div>
        </Modal>
    );
};

export default ExtraChangesModal;
